define('app/factories/report_product_view_factory',['app/setup'],
  function(takhfifan) {
    var viewdProducts = [];
    function isOnScreen(el) {
      var win = $(window);
      var viewport = {
        top: win.scrollTop()
      };
      viewport.bottom = viewport.top + win.height();
      var bounds = el.offset();
      bounds.bottom = bounds.top + el.outerHeight();
      return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    }

    function checkProductView(){
      $('.tkh-report-product-view').each(function(){
        var $this = $(this),
            id = $this.data('id') || $this.data('productId');
        if(isOnScreen($this) && _.lastIndexOf(viewdProducts, id) === -1){
          viewdProducts.push(id);
          $this.removeClass('tkh-report-product-view');
          sendData();
        }
      });
    }

    var sendData = _.debounce(function () {
      var sendingList = _.clone(viewdProducts);
      if(!takhfifan.formKey){
        takhfifan.eventHub.on('formkey', function() {
          sendData();
        });
        return;
      }
      $.ajax({
        url: '/ajax/productrate/view',
        type: "POST",
        data: {
          product_ids:sendingList ,
          form_key: takhfifan.formKey
        }
      });
      viewdProducts = [];
    }, 1000);


    $(window).on('scroll', _.throttle(function(){
      checkProductView();
    },500));
    $(window).on('resize', function(){
      checkProductView();
    });
    checkProductView();
  });

